import styled from 'styled-components';

type BadgeProps = {
  isReadonly?: boolean;
  isSelected?: boolean;
};

export const Badge = styled.button<BadgeProps>`
  align-items: center;
  background-color: transparent;
  border: 1px solid
    ${({ isSelected, theme }) => theme.colors[isSelected ? 'primary' : 'separatorOnWhite']};
  border-radius: 13px;
  cursor: ${({ isReadonly }) => (isReadonly ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 26px;
  font-size: 18px;
  justify-content: center;
  min-width: 50px;
  padding: 0 5px;
`;

export const Counter = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
  margin-left: 3px;
`;
